export enum RouteStatus {
    Planned,
    Started,
    Completed,
    CompletedWithMissing,
    Cancelled,
    Expired,
    Incomplete,
    UserExpired,
    Draft,
    Closed
}
